import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { languageContext } from 'contexts/language_context/LanguageContext';
import { themeContext } from 'contexts/theme_context/ThemeContext';
import { AuthContext } from 'contexts/auth_context/AuthContext';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import LanguageButton from 'components/language_Button/LanguageButton';
import ThemeButton from 'components/theme_button/ThemeButton';
import './Navbar.css';

export default function Navbarr() {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const { webtheme } = useContext(themeContext);
  const { weblanguage, jsonfile } = useContext(languageContext);
  const { isAuth, setAuth, deleteCookie } = useContext(AuthContext);

  const [isLogin, setLogin] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [navData, setNavData] = useState(null);

  // Memoize logo source based on theme
  const logoSrc = useMemo(() => {
    return webtheme === 'dark'
      ? '/Icon/Shift Icon White.svg'
      : '/Icon/Shift Icon Black.svg';
  }, [webtheme]);

  // Load language data
  useEffect(() => {
    if (jsonfile && jsonfile[weblanguage]) {
      setNavData(jsonfile[weblanguage]["Navbar"]);
    }
  }, [weblanguage, jsonfile]);

  // Sync auth state
  useEffect(() => {
    setLogin(isAuth);
  }, [isAuth]);

  const handleLogout = () => {
    deleteCookie();
    setAuth(false);
    setExpanded(false);
    navigate('/login');
  };

  const handleLogin = () => {
    setExpanded(false);
    navigate('/login');
  };

  const handleBrandClick = () => {
    setExpanded(false);
    navigate('/');
  };

  if (!navData) return null;

  const isRTL = weblanguage === 'ar';
  const themeClass = webtheme === 'dark' ? 'dark-mode' : 'light-mode';

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      className={`modern-navbar ${themeClass}`}
      variant={webtheme === 'dark' ? 'dark' : 'light'}
    >
      <Container className="h-100">
        {/* Brand Logo */}
        <Navbar.Brand
          className={`navbar-brand-wrapper ${isRTL ? 'order-lg-2' : 'order-lg-0'}`}
          onClick={handleBrandClick}
        >
          <img
            src={logoSrc}
            alt="Shift EV"
            className="brand-logo"
          />
        </Navbar.Brand>

        {/* Custom Toggler */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler border-0" />

        {/* Collapsible Content */}
        <Navbar.Collapse id="basic-navbar-nav">
          <div className={`navbar-collapse-content d-flex flex-column flex-lg-row w-100 align-items-center gap-3 ${isRTL ? 'justify-content-lg-start' : 'justify-content-lg-end'}`}>

            {/* Desktop: Theme & Language Controls + Logout icon */}
            <div className="d-none d-lg-flex align-items-center gap-3">
              <ThemeButton />
              <LanguageButton />
              {isLogin && (
                <button
                  type="button"
                  className="logout-icon-btn"
                  onClick={handleLogout}
                  title={navData.logout && Object.keys(navData.logout)[0]}
                  aria-label="Logout"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                </button>
              )}
            </div>

            {/* Login Button (unauthenticated only, hidden on /login) */}
            {!isLogin && !isLoginPage && (
              <button
                type="button"
                className="auth-btn"
                onClick={handleLogin}
              >
                {navData.login && Object.keys(navData.login)[0]}
              </button>
            )}

            {/* Mobile: Theme, Language & Logout Controls */}
            <div className="d-flex d-lg-none w-100 justify-content-center align-items-center gap-4 mt-3 mobile-controls">
              <ThemeButton />
              <LanguageButton />
              {isLogin && (
                <button
                  type="button"
                  className="logout-icon-btn"
                  onClick={handleLogout}
                  aria-label="Logout"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                </button>
              )}
              {!isLogin && !isLoginPage && (
                <button
                  type="button"
                  className="auth-btn"
                  onClick={handleLogin}
                >
                  {navData.login && Object.keys(navData.login)[0]}
                </button>
              )}
            </div>

          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
